<style src="./VehiclePixBying.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content">
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="filterReport">
        <div class="row">
          <div class="col-lg-3">
            <div class="form-group">
              <label class="col-sm-12">Placa</label>
              <div class="col-sm-12">
                <input
                  type="text"
                  class="form-control"
                  v-model="licencePlate"
                  placeholder="Ex: ABC1234"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label class="col-sm-12">ID da Transação</label>
              <div class="col-sm-12">
                <input
                  type="text"
                  class="form-control"
                  v-model="transactionId"
                  placeholder="ID da transação"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label class="col-sm-12">Data Início</label>
              <div class="col-sm-12">
                <input
                  type="date"
                  class="form-control"
                  v-model="startDate"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label class="col-sm-12">Data Fim</label>
              <div class="col-sm-12">
                <input
                  type="date"
                  class="form-control"
                  v-model="endDate"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-2">
            <button class="btn btn-lg btn-primary" type="submit">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
        </div>
      </form>
    </div>

    <spinner v-if="showSpinner" />

    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead>
          <tr>
            <th>ID da Transação</th>
            <th>Placa</th>
            <th>Valor</th>
            <th>Status</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in resultList" :key="idx">
            <td>{{ item.transactionId }}</td>
            <td>{{ item.licencePlate }}</td>
            <td>R$ {{ toCurrencyBR(item.amount) }}</td>
            <td>{{ item.status }}</td>
            <td>{{ formatDate(item.createdAt) }}</td>
          </tr>
          <tr v-if="!showSpinner && resultList.length === 0">
            <td colspan="5" class="text-center">Nenhum resultado encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';

export default {
  components: { Spinner },
  data() {
    return {
      showSpinner: false,
      licencePlate: '',
      transactionId: '',
      startDate: this.todayString(),
      endDate: this.todayString(),
      resultList: [],
    };
  },
  methods: {
    todayString() {
      const dt = new Date();
      const mm = ('0' + (dt.getMonth() + 1)).slice(-2);
      const dd = ('0' + dt.getDate()).slice(-2);
      return `${dt.getFullYear()}-${mm}-${dd}`;
    },
    toCurrencyBR(value) {
      if (!value && value !== 0) return '-';
      return (value / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    },
    formatDate(value) {
      if (!value) return '-';
      return new Date(value).toLocaleString('pt-BR');
    },
    async filterReport() {
      if (!this.transactionId && (!this.startDate || !this.endDate)) {
        alert('Informe o ID da Transação ou o período (Data Início e Data Fim).');
        return;
      }

      this.showSpinner = true;
      this.resultList = [];

      const params = {};
      if (this.transactionId) {
        params.transactionId = this.transactionId;
      } else {
        params.startDate = new Date(`${this.startDate}T00:00:00`).toISOString();
        params.endDate = new Date(`${this.endDate}T23:59:59.999`).toISOString();
      }
      if (this.licencePlate) {
        params.licencePlate = this.licencePlate.toUpperCase();
      }

      try {
        const result = await this.$store.dispatch('FINANCIAL-ACCOUNT/GetVehiclePixTransactions', params);
        this.resultList = result.transactions || [];
      } catch {
        this.resultList = [];
      } finally {
        this.showSpinner = false;
      }
    },
  },
};
</script>
